export const orderReceivableStatus = {
  NEW: 'NEW',
  PENDING_INVOICE: 'PENDING_INVOICE',
  INVOICED: 'INVOICED',
  PAID: 'PAID',
  VOID: 'VOID',
  READY_FOR_APPROVAL: 'READY_FOR_APPROVAL',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  UNCLAIMABLE: 'UNCLAIMABLE',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
};

export const bookingJourneyFilter = {
  LEAD_GENERATION: 'LEAD_GENERATION',
  SEMI_AUTOMATIC: 'SEMI_AUTOMATIC',
  INSTANT_BOOK: 'INSTANT_BOOK',
  FULL_AUTOMATIC: 'FULL_AUTOMATIC',
};
